import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";

const MindmapConnectionLabel = props => {
  const style = {
    left: `${props.point.x}px`,
    top: `${props.point.y}px`
  };

  return (
    <div className={`mindmapConnectionLabel ${props.selected ? "selected" : ""}`} style={style}>
      {props.label}
    </div>
  );
};

MindmapConnectionLabel.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  point: PropTypeShapes.point,
  selected: PropTypes.bool.isRequired,
  isFiltered: PropTypes.bool
};

export default MindmapConnectionLabel;
